import { useNavigate, useLocation } from "react-router-dom";
import QRCode from "react-qr-code";

import PrimaryButton from "../../../../../components/Button/Primary";

export default function ConfirmQrMake() {
  const navigate = useNavigate();
  const location = useLocation();
  // 관리자인지 여부 체크 가능하게 되면 createdAdminId null 이 아니라 로직 더 추가 되어야할듯
  const { shelterId, createdAdminId } = location.state || {};

  return (
    <div className="flex flex-col justify-center h-screen">
      <div className="py-10 px-5 flex justify-center">
        <div className="h-[180px] w-[180px] flex items-center justify-center">
          <QRCode
            value={`{"shelterId":"${shelterId}","createdAdminId":null}`}
          />
        </div>
      </div>
      <br />
      <p className="w-full text-center font-black text-2xl">대피 완료 QR코드</p>
      <br />
      <p className="w-full text-center text-[16px] mb-[15px] font-semibold">
        비상대피 장소에 위치한 관리자는 <br />
        QR 이미지를 통해 대피 인원 통제 후 <br />
        대피인증을 진행해 주세요 <br />
      </p>
      <div className="fixed bottom-0 bg-white w-full h-[50px]">
        <PrimaryButton
          className="text-white h-[50px] w-full flex justify-center items-center text-base font-medium leading-[19px]"
          onClick={() => navigate(-1)}
        >
          닫기
        </PrimaryButton>
      </div>
    </div>
  );
}
